import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@material-ui/core'
import api from '../api/client'
import { toFarsiDigits } from '../assets/utils'

/** نام شمسی مرحلهها برای UI */
export const FA_STAGE = {
  read: 'خواندن فایل',
  contractors: 'پیمانکارها',
  contracts: 'قراردادها',
  guarantees: 'ضمانتنامهها',
  restrictions: 'محدودیتها',
  requests: 'صورتوضعیتها',
  transfers: 'حوالهها',
  deductions: 'کسورات',
  treasury: 'اسناد خزانه',
  documents: 'اسناد',
  document_cheques: 'چکهای سند',
  document_transfers: 'انتقال اسناد',
  deposits: 'سپردهها',
  refunds: 'استرداد سپردهها',
  final: 'نهایی‌سازی',
}

/** شریط پیشرفتِ آپلود — زیر چیپ «در حال پردازش» مینشیند (پول هر ۴ ثانیه) */
const UploadProgressInline = ({ deptId, isProcessing }) => {
  const [st, setSt] = useState(null)

  useEffect(() => {
    if (!isProcessing) return undefined
    let alive = true
    const tick = () => api.get(`contracts/upload-status/${deptId}/`)
      .then((r) => { if (alive) setSt(r.data) })
      .catch(() => {})
    tick()
    const t = setInterval(tick, 4000)
    return () => { alive = false; clearInterval(t) }
  }, [deptId, isProcessing])

  if (!isProcessing || !st) return null

  // وضعیت «در صف» — فایل منتظر نوبت پردازش است (آپلود دیگری در جریان است)
  if (st.status === 'queued') {
    return (
      <Box style={{ width: '100%', marginTop: 5 }} data-tour="upload-progress">
        <Typography component="div" style={{ fontSize: 10.5, color: '#b26a00', fontWeight: 700, textAlign: 'center' }}>
          در صف — منتظر نوبت پردازش (فایل دیگری در حال پردازش است)
        </Typography>
        <div style={{ height: 4, borderRadius: 4, background: '#fff3e0', overflow: 'hidden', marginTop: 3 }}>
          <div style={{
            height: '100%',
            width: '36%',
            borderRadius: 4,
            background: 'linear-gradient(90deg, #ff8f00, #ffb74d)',
            animation: 'uploadPulse 1.6s ease-in-out infinite',
          }} />
        </div>
        <style>{'@keyframes uploadPulse { 0%{margin-right:0} 50%{margin-right:64%} 100%{margin-right:0} }'}</style>
      </Box>
    )
  }

  if (st.status !== 'running') return null
  const label = FA_STAGE[st.stage] || st.stage || ''

  // عنوان مرحلهٔ بعدی (بر اساس ترتیب مراحل پردازش)
  const STAGE_ORDER = [
    'read', 'contracts', 'guarantees', 'restrictions', 'requests', 'deductions',
    'treasury', 'documents', 'document_cheques', 'document_transfers',
    'deposits', 'refunds', 'final',
  ]
  let nextLabel = null
  {
    const i = STAGE_ORDER.indexOf(st.stage)
    if (i >= 0 && i < STAGE_ORDER.length - 1) {
      nextLabel = FA_STAGE[STAGE_ORDER[i + 1]] || null
    }
  }
  const pos = st.stage_pos || 0
  const total = st.stage_total || 0
  const pct = st.percent != null
    ? st.percent
    : (total ? Math.min(100, Math.round(pos * 100.0 / total)) : 0)

  // درصد کل عملیات (جمع همهٔ مرحلهها بر پایهٔ شمارش رکوردها)
  const oPct = st.overall != null
    ? st.overall
    : ((st.overall_pos != null && st.overall_total)
      ? Math.min(100, Math.round(st.overall_pos * 100.0 / st.overall_total))
      : null)

  return (
    <Box style={{ width: '100%', marginTop: 5 }} data-tour="upload-progress">
      <Typography component="div" style={{ fontSize: 10.5, color: '#5a64a8', fontWeight: 700, textAlign: 'center' }}>
        {label}
        {pct != null ? ' ' + toFarsiDigits(pct) + '٪' : ''}
        {total ? ' (' + toFarsiDigits(pos) + ' از ' + toFarsiDigits(total) + ')' : ''}
      </Typography>
      {nextLabel && (
        <Typography component="div" style={{ fontSize: 9.5, color: '#9aa1c9', fontWeight: 400, textAlign: 'center' }}>
          مرحلهٔ بعد: {nextLabel}
        </Typography>
      )}
      <div style={{ height: 4, borderRadius: 4, background: '#e8eafd', overflow: 'hidden', marginTop: 3 }}>
        <div style={{
          width: pct + '%',
          height: '100%',
          borderRadius: 4,
          background: 'linear-gradient(90deg, #283593, #7c4dff)',
          transition: 'width .4s ease',
        }} />
      </div>
      {oPct != null && (
        <>
          <Typography component="div" style={{ fontSize: 10, color: '#7a80a3', fontWeight: 700, textAlign: 'center', marginTop: 4 }}>
            کل پردازش {toFarsiDigits(oPct)}٪
          </Typography>
          <div style={{ height: 4, borderRadius: 4, background: '#e3f2fd', overflow: 'hidden', marginTop: 2 }}>
            <div style={{
              width: oPct + '%',
              height: '100%',
              borderRadius: 4,
              background: 'linear-gradient(90deg, #00695c, #26a69a)',
              transition: 'width .4s ease',
            }} />
          </div>
        </>
      )}
    </Box>
  )
}

export default UploadProgressInline
